import isNil from 'lodash/isNil';
import omit from 'lodash/omit';
import { toJS as _toJS, isObservableObject } from 'mobx';

export const toJS = <T = any>(entity?: T | null): any => {
	if (isNil(entity)) return entity;

	let clone = omit(entity as any, ['store']);
	clone = isObservableObject(entity) ? _toJS(clone) : clone;

	return JSON.parse(JSON.stringify(clone));
};
